export const SearchComponent = {
    PRODUCT_RESULT_LIST: "PRODUCT_RESULT_LIST",
    PRODUCT_HITS_PER_PAGE: "PRODUCT_HITS_PER_PAGE",
    PRODUCT_PAGINATION: "PRODUCT_PAGINATION",
    PRODUCT_NUMBER_OF_HITS: "PRODUCT_NUMBER_OF_HITS",
    PRODUCT_FACETS: "PRODUCT_FACETS",
    PRODUCT_SORT: "PRODUCT_SORT",
    CONTENT_RESULT_LIST: "CONTENT_RESULT_LIST",
    CONTENT_HITS_PER_PAGE: "CONTENT_HITS_PER_PAGE",
    CONTENT_PAGINATION: "CONTENT_PAGINATION",
    CONTENT_NUMBER_OF_HITS: "CONTENT_NUMBER_OF_HITS"
} as const;
export type SearchComponentEnum = keyof typeof SearchComponent;
export const SearchComponents = {
    ALL: Object.values(SearchComponent)
};

type ComponentGroup<TString extends string> =
    TString extends `${infer TGroup}_${infer _}` ? TGroup : never;
type ComponentType<TString extends string> =
    TString extends `${infer _}_${infer TType}` ? TType : never;

export type SearchComponentGroup = ComponentGroup<SearchComponentEnum>;
export type SearchComponentType = ComponentType<SearchComponentEnum>;

export type SearchComponentOfGroup<TGroup extends SearchComponentGroup> =
    SearchComponentEnum extends infer TSearchComponentEnum
        ? TSearchComponentEnum extends `${TGroup}_${infer _}`
            ? TSearchComponentEnum
            : never
        : never;
export type SearchComponentOfType<TType extends SearchComponentType> =
    SearchComponentEnum extends infer TSearchComponentEnum
        ? TSearchComponentEnum extends `${infer _}_${TType}`
            ? TSearchComponentEnum
            : never
        : never;

export type BaseSearchComponent = {
    component: SearchComponentEnum;
};
